<template lang="pug">
  .checkbox-list-container
    span.text-small.m4-bottom-3(v-if='title' :class='{bold: labelBold}')
      | {{ title }}
    checkbox.filter(
      v-for='option in options'
      :name='option[keyName]'
      :class='{ hoverableCheckbox: hoverCheckbox }'
      :key='`${name}-${option[keyName]}`'
      :label='setLabel(option[labelName])'
      :checked='isChecked(option[keyName])'
      :updateCheck='updateList'
      :rightCheckbox='rightCheckbox'
      :hoverCheckbox='hoverCheckbox'
      :disabled='isDisabled(option)'
      :disabledText='disabledText'
    )
</template>

<script>
import Checkbox from './Checkbox'

export default {
  components: { Checkbox },
  props: {
    name: { type: String, required: true },
    options: { type: Array, required: true },
    keyName: { type: String, default: 'id' },
    labelName: { type: String, default: 'label' },
    value: { type: Array, default: () => [] },
    title: { type: String },
    setLabel: { type: Function, default: label => label },
    rightCheckbox: { type: Boolean },
    hoverCheckbox: { type: Boolean },
    labelBold: { type: Boolean },
    customIsChecked: { type: Function, default: null },
    customIsDisabled: { type: Function, default: null },
    disabledText: { type: String }
  },
  methods: {
    isChecked(key) {
      return this.customIsChecked ? this.customIsChecked(key) : this.value.includes(key)
    },
    isDisabled(option) {
      return this.customIsDisabled ? this.customIsDisabled(option[this.keyName]) : option.disabled
    },
    removeValue(key) {
      this.$emit('update', this.name, this.value.filter(val => val !== key))
    },
    updateList(key) {
      if (this.value.includes(key)) {
        this.removeValue(key)
        this.$emit('callback', this.name, key, false)
      } else {
        this.$emit('update', this.name, this.value.concat(key))
        this.$emit('callback', this.name, key, true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter:not(:last-child):not(.hoverableCheckbox) {
  margin-bottom: 12px;
}
</style>
